import { render } from "./BenefitQuotesAndClaims.vue?vue&type=template&id=49b8898e&scoped=true"
import script from "./BenefitQuotesAndClaims.vue?vue&type=script&lang=js"
export * from "./BenefitQuotesAndClaims.vue?vue&type=script&lang=js"

import "./BenefitQuotesAndClaims.vue?vue&type=style&index=0&id=49b8898e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b8898e"]])

export default __exports__